import React from 'react';
import { IconProps } from './types';

export const IconEdit: React.FC<IconProps> = ({ size = 32, ...rest }) => {
    return (
      <svg version="1.1" height={size} width={size} id="Camada_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 337.59 336.73" style={{enableBackground: "new 0 0 337.59 336.73"}} space="preserve">

<circle fill="#FFFFFF" stroke="#4E0F9F" strokeMiterlimit="10" cx="168.37" cy="168.37" r="168.37"/>
<g id="IYcT4g.tif_00000082329359679781951620000003650485215159866244_">
	<g>
		<path fill="#4E0F9F" d="M248.86,121.98c-0.24,1.08-0.44,2.17-0.72,3.25c-1.01,3.92-2.92,7.35-5.79,10.22
			c-30.33,30.35-60.66,60.69-91.03,91c-0.86,0.86-2.1,1.48-3.28,1.87c-18.02,6.06-36.05,12.06-54.08,18.09
			c-0.25,0.08-0.48,0.24-0.71,0.36c-0.67,0-1.34,0-2.01,0c-3.55-2.08-4.01-3.34-2.66-7.41c5.9-17.74,11.79-35.47,17.74-53.19
			c0.39-1.17,1.11-2.34,1.98-3.21c30.05-30.11,60.12-60.2,90.21-90.27c9.38-9.38,22.86-9.38,32.31-0.03
			c3.62,3.58,7.17,7.22,10.82,10.77c3.82,3.71,6.26,8.1,6.96,13.41c0.04,0.27,0.17,0.52,0.26,0.78
			C248.86,119.07,248.86,120.53,248.86,121.98z M194.36,109.86c-25.6,25.61-51.27,51.28-76.7,76.72
			c10.1,10.1,20.31,20.31,30.44,30.45c25.49-25.49,51.13-51.14,76.69-76.7C214.64,130.17,204.43,119.94,194.36,109.86z
			 M231.47,133.74c1.64-1.6,3.34-3.14,4.9-4.81c4.75-5.1,4.92-12.83,0.16-17.95c-4.18-4.5-8.57-8.81-13.03-13.03
			c-3.04-2.88-6.81-3.84-11.01-3.21c-5.41,0.81-8.32,4.97-11.74,8.28C211.06,113.33,221.24,123.51,231.47,133.74z M139.26,221.94
			c-8.9-8.9-17.76-17.76-26.66-26.67c-4.38,13.11-8.81,26.35-13.38,40C112.87,230.73,126.16,226.31,139.26,221.94z"/>
	</g>
</g>
</svg>
    );
  };